import baseUrl from '../api/baseUrl';

/**
 * Public URL of the browser tab icon uploaded on the Branding page. The version goes on the
 * query string because the media endpoint caches by path and query for 7 days, so an unchanged
 * URL keeps serving the old icon.
 */
const webIconUrl = (version: string) =>
    `${baseUrl}/api/media/branding/web-icon.png?v=${encodeURIComponent(version)}`;

export default webIconUrl;
